module.exports = __webpack_public_path__ + "static/media/maths.c5bbc254.png";